export const createPages = (userMail, arrSubjects) => {
  return {
    Teacher: [
      {
        name: 'students',
        route: '/students',
        type: 'dropdown students-teacher',
        dropList: [
          { link: 'students', name: 'individual students' },
          { link: 'student-groups', name: 'groupsList' },
        ],
      },
      {
        name: 'materials',
        route: '/materials',
        type: 'link',
      },
      {
        name: 'schedule',
        route: `/schedule/${userMail}`,
        type: 'link',
      },
      {
        name: 'checkLists',
        route: '/checklist-table',
        type: 'dropdown checkLists',
        dropList: [
          { link: 'checklist-create', name: 'checklist-create' },
          { link: 'checklist-table', name: 'checklist-table' },
        ],
      },
      {
        name: 'hw',
        route: '/hw-table',
        type: 'dropdown checkLists',
        dropList: [
          { link: 'hw-create', name: 'hw-create' },
          { link: 'hw-table', name: 'hw-table' },
        ],
      },
      {
        name: 'exams-tab',
        route: '/exam-table',
        type: 'dropdown checkLists',
        dropList: [
          { link: 'exam-create', name: 'exam-create' },
          { link: 'exam-table', name: 'exam-table' },
        ],
      },
    ],
    Student: [
      // {
      //   name: 'schedule',
      //   route: '/schedule',
      //   type: 'link',
      // },
      // Uncomment 'schedule' if you want to enable it
      // {
      //   name: 'library',
      //   route: '/library',
      //   type: 'link',
      // },
    ],
    NewAdmin: [
      {
        name: 'teachers',
        route: '/teachers',
        type: 'link',
      },
      {
        name: 'students',
        route: '/students',
        type: 'dropdown students-teacher',
        dropList: [
          { link: 'students', name: 'individual students' },
          { link: 'student-groups', name: 'groupsList' },
        ],
      },
      {
        name: 'materials',
        route: '/materials',
        type: 'link',
      },
      {
        name: 'checkLists',
        route: '/checklist-table',
        type: 'dropdown checkLists',
        dropList: [
          { link: 'checklist-create', name: 'checklist-create' },
          { link: 'checklist-table', name: 'checklist-table' },
        ],
      },
      {
        name: 'hw',
        route: '/hw-table',
        type: 'dropdown checkLists',
        dropList: [
          { link: 'hw-create', name: 'hw-create' },
          { link: 'hw-table', name: 'hw-table' },
        ],
      },
      {
        name: 'Statistics',
        route: '/statistics',
        type: 'link',
      },
    ],
    Superadmin: [
      {
        name: 'users',
        route: '/students',
        type: 'dropdown students-teacher',
        dropList: [
          { link: 'teachers', name: 'teachers' },
          { link: 'students', name: 'individual students' },
          { link: 'student-groups', name: 'groupsList' },
        ],
      },
      {
        name: 'materials',
        route: '/materials',
        type: 'link',
      },
      {
        name: 'checkLists',
        route: '/checklist-table',
        type: 'dropdown checkLists',
        dropList: [
          { link: 'checklist-create', name: 'checklist-create' },
          { link: 'checklist-table', name: 'checklist-table' },
        ],
      },
      {
        name: 'exams-tab',
        route: '/exam-table',
        type: 'dropdown checkLists',
        dropList: [
          { link: 'exam-create', name: 'exam-create' },
          { link: 'exam-table', name: 'exam-table' },
        ],
      },
      {
        name: 'hw',
        route: '/hw-table',
        type: 'dropdown checkLists',
        dropList: [
          { link: 'hw-create', name: 'hw-create' },
          { link: 'hw-table', name: 'hw-table' },
        ],
      },
      {
        name: 'schedule',
        route: `/schedule/${userMail}`,
        type: 'link',
      },
      {
        name: 'Statistics',
        route: '/statistics',
        type: 'link',
      },
    ],
  };
};

export const languages = [
  {
    lang: 'ua',
  },
  {
    lang: 'ru',
  },
];
